import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import UserPosts from '../../components/Post/Posts';
import { GET_USER_POSTS_QUERY } from '../../graphql/resolvers/postQueries/getUserPosts.gql';

export default function PostsPage() {
  // TRIL-149: source the profile from the route param, not Redux. The param is
  // present on first render (no hydration wait → no empty cold-load query), and
  // the server resolves the owner's userId from this username — so /user/<anyone>
  // /posts returns the right user's posts.
  const { username } = useParams<{ username: string }>();

  const { data } = useQuery(GET_USER_POSTS_QUERY, {
    variables: { username: username ?? '' },
    skip: !username,
  });

  return <UserPosts userPosts={data?.getUserPosts ?? []} />;
}
